// extracted by mini-css-extract-plugin
module.exports = {"new-packs__header":"new-packs_new-packs__header__C_rLU"};